import React from 'react';
import { useTranslation } from 'react-i18next';

import './rating.scss';
import {Rating, Typography} from "@mui/material";
import { Mail } from '@vedmarket/ui-kit';
import {COLORS} from "../../config/constants";

type CustomRatingProps = {
    title?: React.ReactNode;
};

const CustomRating = ({ title }: CustomRatingProps) => {

    const { t } = useTranslation()
    const titleToShow = title || t('text__didTheArticleHelpYou')

    return (
        <div className="rating">
            <div>
                <Typography variant='subtitle1' sx={{
                    lineHeight: 1.6,
                }}>
                    {titleToShow}
                </Typography>
                <Rating sx={{
                    marginTop: 2
                }}/>
            </div>
            <Typography
                className='rating__link'
                variant='body2'
                component='a'
                href='mailto:hello@vedmarket.ru'
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    color: COLORS.BLACK,
                    '&:hover': {
                        textDecoration: 'underline',
                    }
                }}
            >
                <Mail style={{ marginRight: '8px', color: COLORS.LIGHT_ACTION }}/>
                {t('text__reportAnError')}
            </Typography>
        </div>
    )
};

export default CustomRating;
